module.exports = __webpack_public_path__ + "img/road-tax.fdaf9826.png";